<template>
  <content-box class="plan-dialog--wrap" width="530px">
    <div class="title">{{ dialogData.title }}</div>
    <div class="status"
      :class="{ highlight: dialogData.highlight }"
      v-html="dialogData.status"/>
    <ul class="info" v-if="dialogData.info">
      <li v-for="(item, index) in dialogData.info" :key="index" v-html="item"></li>
    </ul>
    <div class="action">
      <ui-button
        @click="$emit('onConfirm', dialogData.type)">{{ $t('common.confirm') }}</ui-button>
    </div>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'PlanStatusDialog',
  components: {
    ContentBox,
    UiButton
  },
  props: [
    'dialogData'
  ]
}
</script>

<style lang="scss" scoped>
.plan-dialog--wrap {
  padding: 30px 30px 25px;
  box-sizing: border-box;

  .title {
    font-size: 15px;
    font-weight: bold;
    color: #2f2f2f;
    margin-bottom: 18px;
  }

  .status {
    padding: 30px;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    color: #444;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 1.3;
    margin-bottom: 25px;
    &.highlight {
      color: $brandColor;
    }
  }

  .action {
    text-align: center;
  }

  .info {
    font-size: 13px;
    color: #666;
    margin-bottom: 22px;

    &> li {
      position: relative;
      padding-left: 10px;
      margin-bottom: 8px;

      &::before {
        content: '';
        width: 3px;
        height: 3px;
        background-color: #888;
        position: absolute;
        top: 5px;
        left: 0;
      }
    }
  }
}
</style>
